var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPauseCircleFilled = function SvgPauseCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.015 7.99a8 8 0 1 1-16 0 8 8 0 0 1 16 0ZM5 10.5a1 1 0 1 0 2 0v-5a1 1 0 0 0-2 0v5Zm4 0a1 1 0 1 0 2 0v-5a1 1 0 0 0-2 0v5Z"
  })));
};
export default SvgPauseCircleFilled;